import kr from 'Kr/kr';

export default class IndustryOpinionSlider extends kr.Component {
    init() {
        this.slider = new Swiper(this.$element.querySelector('.js--industry-opinion-swiper'), {
            loopedSlides: 8,
            loop: true,
            autoplay: {
                enabled: true,
                delay: 0,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            slidesPerView: "auto",
            freeMode: true,
            spaceBetween: 30,
            speed: 12000,
            draggable: false
            /*breakpoints: {
                993: {
                    slidesPerView: 3.4,
                    spaceBetween: 30
                }
            }*/
        });
    }
}

kr.registerComponent('.js--industry-opinion', {
    component: IndustryOpinionSlider
});
